export const Roles = [
  'Frontend', 'Backend', 'Fullstack', 'IOS', 'Flutter', 'React Native', 'Android', 'Web3',
];

export const NumOfEmployees = [
  '1-10',
  '11-20',
  '21-50',
  '51-100',
  '101-200',
  '201-500',
  '500+',
];

export const Experience = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const MinBaseSalary = ['0L', '10L', '20L', '30L', '40L', '50L', '60L', '70L'];

export const Type = ['Remote', 'Hybrid', 'In-office'];

export const getJobsByFilters = ({ jobs, filters }) => {
  const { Roles, Experience, jobType, basePay } = filters;
  if (jobs?.length > 0) {
    let newList = [...jobs];
    if (Roles?.length) {
      newList = newList?.filter(i => Roles.every(role => role.toLowerCase() == i.jobRole));
    }
    if (Experience) {
      newList = newList?.filter(i => Experience === i.minExp || Experience === i.maxExp);
    }
    if (jobType?.length) {
      newList = newList?.filter(i => jobType.every(type => type.toLowerCase() == i.location));
    }
    if (basePay) {
      newList = newList?.filter(i => basePay?.slice(0, -1) >= i?.minJdSalary && basePay?.slice(0, -1) <= i?.maxJdSalary);
    }
    return newList;
  }
}